import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@base/Button/Button';
import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import Paper from '@base/Paper/Paper';
import imageHelper from '@utils/imageHelper';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import Drawer from '@base/Drawer/Drawer';
import H5 from '@base/H5/H5';

const Container = styled(Paper)`
  &.container {
    @media (max-width: 47.95em) {
      padding: 24px 16px;
      min-height: 180px;
      margin: 0 16px;
      top: -32px;
      width: calc(100% - 32px);
      position: relative;
      overflow: hidden;
    }
  }
`;

const Image = styled.img`
  width: 124px;
  height: 124px;
  position: absolute;
  right: -27px;
  top: -26px;
`;

const Heading = styled(H2)`
  font-size: 22px;
  &.mb24 {
    margin-bottom: 24px;
  }
`;

const SubHeading = styled(P1)`
  margin: 8px 0 16px;
  width: calc(100% - 80px);
`;

const LearnMore = styled(Button)`
  background-color: #fff;
  min-height: 40px;
  height: 40px;
  color: #08bd80;
  border: 1px solid #f0f4f7;
  display: inline-block;
  width: 114px;
  border-radius: 8px;
  padding: 0;
  font-size: 14px;
`;

const ButtonContainer = styled.div`
  position: fixed;
  height: 72px;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px #f0f4f7;
  padding: 12px 16px;
`;

const ViewAllPricing = styled(Button)`
  width: 100%;
  height: 100%;
  min-height: 100%;
`;

const DrawerContainer = styled.div`
  grid-column: span 10;
`;

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  &.last {
    margin-bottom: 96px;
  }
`;
const Icon = styled.img`
  margin-right: 16px;
`;

const CardTitle = styled(H5)`
  margin-bottom: 8px;
`;

const Logo = styled.img`
  width: 116px;
  height: 72px;
  margin-bottom: 12px;
`;
function MobileIconicSection({ type, info }) {
  const { heading, subHeading, data, logo } = info;
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const { push, route, asPath } = useRouter();
  const onLearnMoreClick = () => {
    setOpenDrawer(true);
  };
  const closeDrawer = () => {
    setOpenDrawer(false);
  };
  const onViewAllPricing = () => {
    push(`${route}/subscribe`, `${asPath}/subscribe`);
  };
  return (
    <>
      <Container className="container">
        <Heading>{heading}</Heading>
        <SubHeading>{subHeading}</SubHeading>
        <LearnMore label="Learn More" onClick={onLearnMoreClick} />
        <Image src={imageHelper.getImage(`goal/${type.toLowerCase()}_1.png`)} />
      </Container>
      <Drawer drawerState={openDrawer} onClose={closeDrawer}>
        <DrawerContainer>
          {logo && <Logo src={imageHelper.getImage(logo)} alt={type} />}
          <Heading className="mb24">{`${type} Subscription`}</Heading>
          {data.map((card, index) => {
            const {
              name,
              description,
              image,
              appIcon,
              benefitDesc,
              benefitHeader
            } = card;
            const icon = appIcon ?? (image ? imageHelper.getImage(image) : '');
            return (
              <Card
                key={String(index)}
                className={data.length - 1 === index ? 'last' : ''}
              >
                {icon ? (
                  <Icon
                    src={icon}
                    alt={name || benefitHeader}
                    width="48"
                    height="48"
                  />
                ) : null}
                <div>
                  <CardTitle>{name || benefitHeader}</CardTitle>
                  <P1>{description || benefitDesc}</P1>
                </div>
              </Card>
            );
          })}
        </DrawerContainer>
        <ButtonContainer>
          <ViewAllPricing label="View all plans" onClick={onViewAllPricing} />
        </ButtonContainer>
      </Drawer>
    </>
  );
}

function areEqual(prevProps, nextProps) {
  return prevProps.info.length === nextProps.info.length;
}

const MemoizedMobileIconicSection = React.memo(MobileIconicSection, areEqual);

export default MemoizedMobileIconicSection;
MobileIconicSection.propTypes = {
  type: PropTypes.string.isRequired,
  info: PropTypes.objectOf(PropTypes.any).isRequired
};
